import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationFR from "../langs/fr.json";
import translationEN from "../langs/en.json";
import translationES from "../langs/es.json";

export const SUPPORTED_LANGUAGES = ["fr", "en", "es"];

type UserLanguageSource = {
  language?: string;
  lang?: string;
  locale?: string;
  real_user?: UserLanguageSource;
};

export function normalizeLanguage(language: unknown): string | null {
  if (!language || typeof language !== "string") {
    return null;
  }

  const normalized = language.toLowerCase().trim().slice(0, 2);
  return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : null;
}

export function getUserLanguage(user: UserLanguageSource = {}): string | null {
  const languageSource = user.real_user || user;
  return normalizeLanguage(languageSource.language || languageSource.lang || languageSource.locale);
}

function getInitialLanguage() {
  try {
    const persistedUser = JSON.parse(localStorage.getItem("userData") || "{}");
    return getUserLanguage(persistedUser) || "fr";
  } catch {
    return "fr";
  }
}

const resources = {
  fr: {
    translation: translationFR,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "fr",
  supportedLngs: SUPPORTED_LANGUAGES,
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
